import {FilterSettings} from "../pages/Home";
import {ChargingStationPOI} from "./APITypes";

export const filterChargingStations = (
  filter: FilterSettings,
  chargingStations: ChargingStationPOI[],
) =>
  chargingStations.filter((poi) => {
    if (
      (filter.reachability === "Unbeschrankt" && poi.behindBarrier) ||
      (filter.reachability === "Beschrankt" && !poi.behindBarrier)
    )
      return false;
    if (
      (filter.occupancy === "Frei" &&
        !poi.circuits.some((circuit) => circuit.status === "Frei")) ||
      (filter.occupancy === "Belegt" &&
        !poi.circuits.some((circuit) => circuit.status === "Belegt"))
    )
      return false;
    if (
      (filter.powerType === "AC" &&
        !poi.circuits.some((circuit) => circuit.powerType === "AC")) ||
      (filter.powerType === "DC" &&
        !poi.circuits.some((circuit) => circuit.powerType === "DC"))
    )
      return false;

    return true;
  });
